import { Modal, Typography } from "antd";
const ExitAreYouSure = ({ isOpen, onOk, onCancel }) => {
  return (
    <>
      <Modal
        title="Are you sure?"
        centered
        open={isOpen}
        onCancel={onCancel}
        okText="Yes"
        cancelText="No"
        onOk={onOk}
        width={440}
      >
        <Typography className="text-sm mb-4">
          You want to exit, your filled info will be lost.
        </Typography>
      </Modal>
    </>
  );
};
export default ExitAreYouSure;
